import { useState, useEffect } from "react";
import { Frame, Loading, Header, ValidaUid } from "../components";
import { db } from "../config/firebase";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";

const Contato = () => {
  const [dados, setDados] = useState({});
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const buscaDados = async () => {
    const uid = await ValidaUid();

    if (uid) {
      const qry = await getDoc(doc(db, "desconto2026", uid));

      const data = qry.data();

      if (!data?.status) {
        setLoading(false);
      } else if (data?.status === "e") {
        setLoading(false);
        setDados(data);
      } else {
        navigate("../home");
      }
    }
  };

  useEffect(() => {
    buscaDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading && <Loading />}
      <Header nome={dados?.nome} foto={dados?.urlFoto} />

      <Frame
        body={
          <div className="justify">
            <p>Whatsapp: (53) 99125-5743</p>
            <p>Telefone: (53) 3278-7000</p>
            <p>De segunda à sexta, das 08:30 às 11:30 e das 14:00 às 17:30</p>
          </div>
        }
        title="Fale Conosco"
      />
    </>
  );
};

export default Contato;
